// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file subscription_plan.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file subscription_plan.proto.
 */
export const file_subscription_plan: GenFile = /*@__PURE__*/
  fileDesc("ChdzdWJzY3JpcHRpb25fcGxhbi5wcm90bxIGZG9tYWluKm4KEFN1YnNjcmlwdGlvblBsYW4SHQoZU1VCU0NSSVBUSU9OX1BMQU5fVU5LTk9XThAAEh0KGVNVQlNDUklQVElPTl9QTEFOX01PTlRITFkQARIcChhTVUJTQ1JJUFRJT05fUExBTl9ZRUFSTFkQAkIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM");

/**
 * @generated from enum domain.SubscriptionPlan
 */
export enum SubscriptionPlan {
  /**
   * used as default value, see https://developers.google.com/protocol-buffers/docs/proto3#enum
   *
   * @generated from enum value: SUBSCRIPTION_PLAN_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_PLAN_MONTHLY = 1;
   */
  MONTHLY = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_PLAN_YEARLY = 2;
   */
  YEARLY = 2,
}

/**
 * Describes the enum domain.SubscriptionPlan.
 */
export const SubscriptionPlanSchema: GenEnum<SubscriptionPlan> = /*@__PURE__*/
  enumDesc(file_subscription_plan, 0);

